// Stub stash — hooks read from staticData instead of the chain stash.
export const stash = {};
